import { useState } from "react";

import { LazyImage } from "@/components/Image/LazyImage";
import { ImageCarousel } from "@/components/ImageCarousel/ImageCarousel";
import { HotelGalleryIndicators } from "@/features/hotels/components/hotel/HotelGalleryIndicators";
import { HotelImageCounter } from "@/features/hotels/components/hotel/HotelImageCounter";
import type { ImageData } from "@/types/types";

type HotelImageCarouselProps = {
  images: ImageData[];
  onClick?: () => void;
};

export const HotelImageCarousel = ({
  images,
  onClick,
}: HotelImageCarouselProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  return (
    <div className="relative w-full overflow-hidden rounded-t-2xl">
      <ImageCarousel
        items={images}
        loop={false}
        getItemKey={({ url }) => url}
        onSlideChange={setCurrentIndex}
        className="aspect-[35/24]"
        slideClassName="h-full"
        slides={{ perView: 1, spacing: 0, origin: "auto" }}
        renderItem={({ url, alt }) => (
          <button type="button" onClick={onClick} className="h-full w-full">
            <LazyImage
              src={url}
              alt={alt}
              className="h-full w-full object-cover"
              rootMargin="0px 100px 0px 100px"
            />
          </button>
        )}
      />

      {images.length > 1 && (
        <div className="absolute start-3 bottom-3">
          <HotelImageCounter count={images.length} />
        </div>
      )}

      <HotelGalleryIndicators
        totalImages={images.length}
        currentIndex={currentIndex}
      />
    </div>
  );
};
